import React from 'react';
import NursingCareCatalogManager from '../../head-doctor/nursing/NursingCareCatalogManager';
import { MAJOR_COPY } from '../majorCopy';

export default function MajorNursingCarePage() {
  return <NursingCareCatalogManager copy={MAJOR_COPY.NURSING_CARE_CATALOG} />;
}
